import { render, staticRenderFns } from "./forget-pwd.vue?vue&type=template&id=ee5caff0&scoped=true"
import script from "./forget-pwd.vue?vue&type=script&lang=js"
export * from "./forget-pwd.vue?vue&type=script&lang=js"
import style0 from "./forget-pwd.vue?vue&type=style&index=0&id=ee5caff0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5caff0",
  null
  
)

export default component.exports